import { get } from '@alltrails/shared/api';
import { Map } from '@alltrails/shared/types/map';

export default async function getMap(mapId: number) {
  return get<{ maps?: Map[] }>(`/api/alltrails/maps/${mapId}`, { params: { detail: 'deep' } }).then(({ maps }) => {
    if (maps?.length) {
      return maps[0];
    }
    return undefined;
  });
}
